
import React, { Component } from 'react';
import { Link } from 'react-router-dom';

const aboutTitle = "About Kagont";
const aboutDesc = "Energistica coordinate highly eficient procesr improvement viaing awesome";
const newsTitle = "our Recent news";
const letterTitle = "Our News Letter";
const letterDesc = "Kagont is a event organization supported by community leaders";

const footerInfoList = [
    {
        imgUrl: 'assets/images/footer/footer-top/01.png',
        imgAlt: 'footer icon',
        text: 'Phone Number : +88019 339 702 520',
    },
    {
        imgUrl: 'assets/images/footer/footer-top/02.png',
        imgAlt: 'footer icon',
        text: 'Email : admin@Kagont.com',
    },
    {
        imgUrl: 'assets/images/footer/footer-top/03.png',
        imgAlt: 'footer icon',
        text: 'Address : 30 North West New York 240',
    },
]

const newsFooterList = [
    {
        imgUrl: 'assets/images/footer/footer-middle/01.jpg',
        imgAlt: 'footer-middle',
        title: 'Evisculate Economicy Sound Technologies Before.',
        date: 'Jun 24, 2022',
    },
    {
        imgUrl: 'assets/images/footer/footer-middle/02.jpg',
        imgAlt: 'footer-middle',
        title: 'Globally initiate Global Niche Awesome Markets For.',
        date: 'Jun 24, 2022',
    },
    {
        imgUrl: 'assets/images/footer/footer-middle/03.jpg',
        imgAlt: 'footer-middle',
        title: 'Authorita Underwhni Tactica Growth Stratege Create',
        date: 'Jun 24, 2022',
    },
]



export default class Footer extends Component {
    render() {
        return (
            <footer className="footer-section" style={{backgroundImage: "url(/assets/images/bg-images/footer-bg.png)"}}>
                <div className="footer-top">
                    <div className="container">
                        <div className="row g-3 justify-content-center g-lg-0">
                            {footerInfoList.map((val, i) => (
                                <div className="col-lg-4 col-sm-6 col-12" key={i}>
                                    <div className="footer-top-item lab-item">
                                        <div className="lab-inner">
                                            <div className="lab-thumb">
                                                <img src={`${val.imgUrl}`} alt={`${val.imgAlt}`} />
                                            </div>
                                            <div className="lab-content">
                                                <span>{val.text}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
                <div className="footer-middle padding-tb">
                    <div className="container">
                        <div className="row shape-c">
                            <div className="col-lg-4 col-md-6 col-12">
                                <div className="footer-middle-item-wrapper">
                                    <div className="footer-middle-item mb-5 mb-lg-0">
                                        <div className="fm-item-title">
                                            <h5>{aboutTitle}</h5>
                                        </div>
                                        <div className="fm-item-content">
                                            <p className="mb-30">{aboutDesc}</p>
                                            <img className="rounded footer-abt-img" src="assets/images/footer/footer-middle/01.jpg" alt="about-image" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 col-12">
                                <div className="footer-middle-item-wrapper">
                                    <div className="footer-middle-item mb-5 mb-lg-0">
                                        <div className="fm-item-title">
                                            <h5>{newsTitle}</h5>
                                        </div>
                                        <div className="fm-item-content">
                                            {newsFooterList.map((val, i) => (
                                                <div className="fm-item-widget lab-item" key={i}>
                                                    <div className="lab-inner">
                                                        <div className="lab-thumb">
                                                            <Link to="/blog-single"><img src={`${val.imgUrl}`} alt={`${val.imgAlt}`} /></Link>
                                                        </div>
                                                        <div className="lab-content">
                                                            <h6><Link to="/blog-single">{val.title}</Link></h6>
                                                            <p>{val.date}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 col-12">
                                <div className="footer-middle-item-wrapper">
                                    <div className="footer-middle-item-3 mb-5 mb-lg-0">
                                        <div className="fm-item-title">
                                            <h5>{letterTitle}</h5>
                                        </div>
                                        <div className="fm-item-content">
                                            <p>{letterDesc}</p>
                                            <form>
                                                <div className="form-group">
                                                    <input type="email" className="form-control" placeholder="Enter email" />
                                                </div>
                                                <button type="submit" className="lab-btn">Send Massage <i className="icofont-paper-plane"></i></button>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="footer-bottom">
                    <div className="container">
                        <div className="row">
                            <div className="col-12">
                                <div className="footer-bottom-content text-center">
                                    <p>&copy;2022 <Link to="/">Kagont</Link> -Best For Event React Template.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        )
    }
}
